<template>
  <Icon :component="CartSvg" class="icon" />
</template>

<script lang="ts">
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import CartSvg from './svg/CartSvg.vue';

export default defineComponent({
  name: 'CartIcon',
  components: {
    Icon
  },
  props: {},
  data() {
    return {
      CartSvg: markRaw(CartSvg)
    };
  }
});
</script>

<style lang="scss" scoped>
.icon {
  color: $primary-color;
  &:hover {
    color: $primary-hover-color;
  }
}
</style>
